export class StringUtils {
  public static isEmpty(str): boolean {
    return !str || 0 === str.length;
  }

  public static checkIfStringsMatch(
    str1: string,
    str2: string,
    ignoreChars: RegExp,
    replaceDiacritics = true,
  ): boolean {
    let strippedStr1 = str1.toLocaleLowerCase().replace(ignoreChars, '');
    let strippedStr2 = str2.toLocaleLowerCase().replace(ignoreChars, '');

    if (replaceDiacritics) {
      strippedStr1 = this.replaceDiacritics(strippedStr1);
      strippedStr2 = this.replaceDiacritics(strippedStr2);
    }

    return strippedStr1.indexOf(strippedStr2) > -1;
  }

  public static pad(number: number | string, size: number): string {
    let numString = `${number}`;

    while (numString.length < size) {
      numString = '0' + numString;
    }

    return numString;
  }

  public static replaceDiacritics(str: string): string {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace('ł', 'l');
  }
}



// WEBPACK FOOTER //
// ./src/utils/string-utils.ts